import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Icon, { Icon20 } from 'builder/components/Icon'
import { rotation } from 'builder/styles/keyframes'
import Media from 'builder/styles/media'
import { ButtonV2 } from 'builder/components/Button'

export const Container = styled.div`
  width: 520px;
  border-radius: 16px;
  padding: 48px 52px;
  background: ${Colors.White};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  gap: 40px;

  ${Media.Phone`
    min-height: unset;
    border-radius: 0px;
    height: 100%;
    padding: 76px 36px 36px;
    overflow: auto;
    justify-content: space-between;
  `}
`

export const Title = styled.p`
  ${Typography.M};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
  text-align: center;
`

export const SubTitle = styled.p`
  ${Typography.Body};
  color: ${Colors.Neutral50};
  text-align: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const TextFieldContainer = styled.div`
  width: 100%;
  margin-bottom: 8px;
`

export const ValidationLoadingIcon = styled(Icon.Spinner)`
  color: ${Colors.Blue50};
  animation: ${rotation} 0.5s linear infinite;
`

export const ValidationSuccessIcon = styled(Icon.Success)`
  fill: ${Colors.Green50};
`

export const ValidationFailIcon = styled(Icon20.WarningCircle)`
  color: ${Colors.Red50};
  width: 16px;
  height: 16px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`

export const ErrorContentContainer = styled(ContentContainer)`
  gap: 12px;
`

export const Button = styled(ButtonV2)`
  ${Media.Phone`
    width: 100%;
  `}
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 13px;

  ${Media.Phone`
    gap: 8px;
  `}
`

export const ErrorHeaderWrapper = styled(HeaderWrapper)`
  padding: unset;
`

export const ProfileHeaderWrapper = styled(HeaderWrapper)`
  padding: 0 66px;
`

export const LinkedInProfileHeading = styled(Title)`
  margin-bottom: 42px;
  ${Media.Phone`
    margin-bottom: 32px;
  `}
`

export const LinkedInProfileCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FullName = styled.div`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
  max-width: 272px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Position = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  max-width: 272px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TryAnotherLink = styled.div`
  ${Typography.Caption}
  ${FontWeights.DemiBold};
  color: ${Colors.Blue50};
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 9px;
`

export const RevertIcon = styled(Icon.Revert)`
  color: ${Colors.Blue50};
  height: 20px;
  width: 20px;
`

export const LinkedInErrorSubheading = styled(SubTitle)``

export const LinkedInErrorImg = styled.img`
  width: 88px;
  height: 120px;
  margin-top: 48px;
  margin-bottom: 12px;
  ${Media.Phone`
    margin-top: 100px;
    margin-bottom: 24px;
  `}
`

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;
`

export const Image = styled.img`
  width: 160px;
  height: 100px;
`

export const LinkedInImage = styled.img`
  width: 90px;
  height: 90px;
  position: absolute;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Avatar = styled.img`
  width: 160px;
  height: 100px;
  position: absolute;
`

export const LinkedInImageDoodle = styled.img`
  width: 24px;
  height: 24px;
  position: absolute;
  top: -45px;
  left: -50px;
`

export const ErrorImage = styled.img`
  width: 88px;
  height: 120px;
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 48px;
  right: 48px;

  ${Media.Phone`
    top: 5px;
    right: 5px;
  `}
`

export const CloseIcon = styled(Icon20.Close)`
  color: ${Colors.Neutral50};
  position: absolute;
  border-radius: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  background: ${Colors.Neutral10};

  &:hover {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }

  ${Media.Phone`
    width: 24px;
    height: 24px;
    padding: 2px;
    top: 20px;
    right: 20px;
  `};
`

export const BackButton = styled(ButtonV2)`
  border-radius: 20px;
  position: absolute;
  top: 32px;
  left: 24px;
  height: 32px;
  background-color: ${Colors.Neutral10};
  color: ${Colors.Neutral50};
  ${FontWeights.DemiBold};

  &:hover {
    background-color: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }

  ${Media.Phone`
    top: 20px;
    left: 20px;
  `};
`

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const InfoContainer = styled.div`
  display: inline-flex;
  padding: 16px 32px 12px;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.4) 100%),
    rgba(26, 145, 240, 0.1);
  box-shadow: 0px 1.099px 5.897px 0px rgba(26, 145, 240, 0.2) inset;
  margin-top: 36px;
`

export const ProfileButtonContainer = styled(ButtonContainer)`
  ${Media.Phone`
    flex-direction: column-reverse;
    align-items: center;
    gap: ${Spacing.M};
    margin-bottom: 12px;
  `}
`

export const ErrorButtonContainer = styled(ButtonContainer)`
  ${Media.Phone`
    flex-direction: column-reverse;
    align-items: center;
    gap: ${Spacing.M};
  `}
`
